export const UPGRADE_BANNER_BG_IMAGE =
  'https://static.rfstat.com/renderforest/images/website_maker_images/upgrade_banner_bg.png'
export const UPGRADE_BANNER_MOBILE_BG_IMAGE =
  'https://static.rfstat.com/renderforest/images/website_maker_images/upgrade_banner_mobile_bg.png'
